/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_2_Item_AnalyticsInputs */

const en_privacy_section_2_item_analytics = /** @type {(inputs: Privacy_Section_2_Item_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytics data`)
};

const lv_privacy_section_2_item_analytics = /** @type {(inputs: Privacy_Section_2_Item_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analītikas dati`)
};

/**
* | output |
* | --- |
* | "Analytics data" |
*
* @param {Privacy_Section_2_Item_AnalyticsInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_2_item_analytics = /** @type {((inputs?: Privacy_Section_2_Item_AnalyticsInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_2_Item_AnalyticsInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_2_item_analytics(inputs)
	return en_privacy_section_2_item_analytics(inputs)
});